import { JourneyStage, PatientJourneyStage, ProviderJourneyStage } from 'types';

interface StepInternalColor {
  backgroundLight: string;
}

const stepColors: Record<JourneyStage, StepInternalColor> = {
  [JourneyStage.GUIDELINES]: { backgroundLight: '#DFE7ED' },
  [JourneyStage.PRE_TRAINING]: { backgroundLight: '#E5EAF0' },
  [JourneyStage.PATIENT_RISKS]: { backgroundLight: '#EFF2F2' },
  [JourneyStage.POST_TRAINING]: { backgroundLight: '#E5EAF0' },
  [JourneyStage.PATIENT_OUTCOMES]: { backgroundLight: '#E7F4FA' },
  [JourneyStage.NAVIGATING_DECISIONS]: { backgroundLight: '#F5EDEE' },
  [JourneyStage.PATIENT_EXPECTATIONS]: { backgroundLight: '#FFFBF7' },
  [JourneyStage.PROVIDER_DISCUSSIONS]: { backgroundLight: '#F6F2EF' },
};

export const isERPStep = (codeName: string) =>
  codeName === ProviderJourneyStage.ERP_WORKFLOW ||
  codeName === PatientJourneyStage.ENHANCED_RECOVERY_JOURNEY;

export const getStepData = (
  color: string,
  codeName: string
): StepInternalColor => {
  return stepColors[codeName as JourneyStage] ?? { backgroundLight: color };
};

export type FormStepStages =
  | JourneyStage.PRE_TRAINING
  | JourneyStage.POST_TRAINING;

export const FormStepDuration: Record<FormStepStages, string> = {
  [JourneyStage.PRE_TRAINING]: '02:00 mins',
  [JourneyStage.POST_TRAINING]: '02:00 mins',
};
